import {
  buildReviewableCandidateShell,
  buildReviewableOrigin,
  REVIEWABLE_ORIGIN_COLLECTIONS,
  REVIEWABLE_ORIGIN_TYPES,
} from '../features/reviewableItems/reviewableItemFlow';

const normalizeText = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

export const ALLERGY_REVIEW_DOMAIN = 'allergy';
export const ALLERGY_REVIEW_ALLOWED_ACTIONS = ['add_allergy', 'ignore'];

export const isAllergySuggestion = (item = {}) => {
  const text = normalizeText([
    item.title,
    item.content,
    item.summary,
    item.sourceText,
    item.metadata?.sourceSection,
  ].filter(Boolean).join(' '));
  const type = normalizeText(item.knowledgeType || item.category).toLowerCase();

  if (!/\ballerg(?:y|ies|ic)\b/i.test(text)) return false;
  return ['profile', 'risk', 'condition', 'feeding', 'safety', 'other', 'note', ''].includes(type);
};

export const getAllergySuggestionValue = (item = {}) => normalizeText(
  typeof item === 'string'
    ? item
    : item.content || item.summary || item.title || item.value || item.sourceText
);

export const buildAllergyReviewCandidate = ({
  origin = {},
  extractedItem = {},
  confidence = '',
  suggestedAction = 'add_allergy',
} = {}) => {
  const value = getAllergySuggestionValue(extractedItem);
  const sourceText = normalizeText(extractedItem.sourceText || origin.sourceText || value);
  const savedOrigin = buildReviewableOrigin({
    id: origin.id,
    type: origin.type || REVIEWABLE_ORIGIN_TYPES.KNOWLEDGE_ITEM,
    collection: origin.collection || REVIEWABLE_ORIGIN_COLLECTIONS.KNOWLEDGE_ITEMS,
    childId: origin.childId,
    sourceText,
    sourceSaved: origin.sourceSaved !== false,
    metadata: origin.metadata || {},
  });

  return {
    ...buildReviewableCandidateShell({
      origin: savedOrigin,
      domain: ALLERGY_REVIEW_DOMAIN,
      label: value || 'Allergy',
      sourceText,
      allowedActions: ALLERGY_REVIEW_ALLOWED_ACTIONS,
      suggestedAction,
      confidence,
      payload: { value },
    }),
    extracted: { value, sourceText },
  };
};
